import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59e63f24"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact" }, " 联系我们，一起创造新酒店！ ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "call_text",
  marker: "tiger"
}, [
  /*#__PURE__*/_createTextVNode(" 关注华美酒店顾问公众号，"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode("分享最新行业大数据！ ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialMedia = _resolveComponent("SocialMedia")!

  return (_openBlock(), _createElementBlock("div", {
    class: "call_wrapper",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/contact-us')))
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "_wrap_call",
      id: "CallForAction",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _hoisted_2,
      _createVNode(_component_SocialMedia, { class: "social_media" })
    ])
  ]))
}